import {useState, useEffect} from "react";

export const useWindowWidth = () => {
    const getWidth = () => window?.innerWidth ?? 0;
    const [width, setWidth] = useState(getWidth());

    useEffect(() => {
        let timeoutId;

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setWidth(getWidth());
            }, 0);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return width;
};
